import React from 'react';
import { FadeIn } from './FadeIn';
import { Copy, Code, AlertTriangle } from 'lucide-react';
export function TruthSection() {
  return <section className="bg-cream-100 py-10 md:py-16" data-id="element-253">
      <div className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-254">
        <FadeIn data-id="element-255">
          <div className="text-center mb-5 md:mb-6" data-id="element-256">
            <h2 className="text-2xl md:text-4xl mb-3 md:mb-4 leading-snug" data-id="element-257">
              Most Moms Just Pay The Bill
              <br className="md:hidden" data-id="element-258" /> And Move On
            </h2>
            <p className="text-sm md:text-lg text-brown-800 max-w-xs md:max-w-xl mx-auto leading-relaxed" data-id="element-259">
              Between work, kids, appointments, and everything else life throws
              your way…
            </p>
            <p className="text-sm md:text-lg text-brown-800 max-w-xs md:max-w-xl mx-auto leading-relaxed mt-2 md:mt-3" data-id="element-260">
              Medical bills are often something moms handle quickly just to get
              them off the to-do list.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-261">
          <p className="text-center text-sm md:text-lg text-brown-800 max-w-xs md:max-w-xl mx-auto leading-relaxed mb-4 md:mb-6" data-id="element-262">
            But many hospital bills can include things like:
          </p>

          <div className="flex flex-col items-center gap-2 md:flex-row md:flex-wrap md:justify-center md:gap-4 mb-6 md:mb-8" data-id="element-263">
            {[{
            label: 'Duplicate charges',
            icon: Copy
          }, {
            label: 'Incorrect billing codes',
            icon: Code
          }, {
            label: 'Unexpected fees',
            icon: AlertTriangle
          }].map((item, i) => <span key={i} className="bg-white px-4 py-2 rounded-full text-brown-800 text-sm md:text-base font-medium shadow-sm border border-cream-200 flex items-center w-fit" data-id="element-264">
                <item.icon className="w-4 h-4 text-terracotta-500 mr-2 flex-shrink-0" data-id="element-265" />
                {item.label}
              </span>)}
          </div>

          <p className="text-center text-sm md:text-lg text-brown-800 max-w-xs md:max-w-xl mx-auto leading-relaxed mb-2 md:mb-3" data-id="element-266">
            Most families simply pay the bill without ever reviewing the
            details.
          </p>
          <p className="text-center text-base md:text-xl font-semibold text-brown-600 max-w-xs md:max-w-xl mx-auto leading-snug" data-id="element-267">
            Taking a few minutes to understand the charges could help you avoid
            paying more than necessary.
          </p>
        </FadeIn>
      </div>
    </section>;
}